import styled from 'styled-components';
import { DESKTOP_BREAKPOINT } from '../../utils';

interface CarouselContainerProps {
	$numberOfItems: number;
}

export const Container = styled.div`
	padding: 0 !important;
	width: 100% !important;
`;

export const TopSection = styled.section`
	display: flex;
	flex-direction: column;
	align-items: center;
	background-color: ${({ theme }) => theme.colors.neutral.white};
	padding: 32px 0;
`;

export const CardsContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(5, 1fr);
	gap: 24px;
	margin: 32px;
	padding: 0 16px;
	max-width: 1200px;
	width: 100%;

	> a {
		width: auto;
	}

	> article {
		cursor: pointer;
	}

	@media (max-width: ${DESKTOP_BREAKPOINT}px) {
		grid-template-columns: repeat(2, 1fr);
		gap: 12px;
	}
`;

export const CarouselContainer = styled.div<CarouselContainerProps>`
	padding: 0 16px;
	max-width: 1200px;
	width: 100%;
	margin-top: -24px;

	.react-multiple-carousel__arrow--left:before {
		content: '⏴';
		line-height: 0;
	}

	.react-multiple-carousel__arrow--right:before {
		content: '⏵';
		line-height: 0;
	}

	.react-multi-carousel-list {
		justify-content: ${({ $numberOfItems }) => ($numberOfItems < 6 ? 'center' : 'initial')};
	}

	> div {
		padding: 24px 0 0;
	}

	li {
		display: flex;
		align-items: stretch;
	}

	@media (max-width: ${DESKTOP_BREAKPOINT}px) {
		.react-multi-carousel-list {
			justify-content: ${({ $numberOfItems }) => ($numberOfItems < 2 ? 'center' : 'initial')};
		}
	}
`;

export const CarouselItem = styled.div`
	width: 176px;

	@media (max-width: ${DESKTOP_BREAKPOINT}px) {
		width: 100%;
		display: flex;
		justify-content: center;
		padding: 0 4px;
	}
`;

export const BottomSection = styled.section`
	display: flex;
	gap: 24px;
	padding: 32px 16px;
	margin: auto;
	max-width: 1200px;
	width: 100%;
`;

export const FiltersAside = styled.aside`
	display: flex;
	flex-direction: column;
	gap: 32px;
	width: 276px;

	@media (max-width: ${DESKTOP_BREAKPOINT}px) {
		display: none;
	}
`;

export const SortCard = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	background-color: ${({ theme }) => theme.colors.neutral.white};
	border-radius: 12px;
	padding: 16px;
	width: 100%;

	> div {
		display: flex;
		align-items: center;

		@media (max-width: ${DESKTOP_BREAKPOINT}px) {
			width: 100%;
			justify-content: space-between;
		}

		> span {
			display: flex;
			font-weight: 700;
			margin-right: 16px;
		}
	}

	@media (max-width: ${DESKTOP_BREAKPOINT}px) {
		flex-direction: column;
		align-items: end;
		gap: 20px;
	}
`;

export const DropdownContainer = styled.div`
	max-width: 280px;
	width: 100%;

	@media (max-width: ${DESKTOP_BREAKPOINT}px) {
		max-width: 400px;
	}
`;

export const MainSection = styled.section`
	display: flex;
	flex-direction: column;
	flex: 1;
	gap: 24px;
`;

export const CardsGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 16px;

	@media (max-width: 480px) {
		display: flex;
		flex-direction: column;
	}

	@media (max-width: 768px) {
		grid-template-columns: repeat(2, 1fr);
	}
`;

export const DesktopFilter = styled.div`
	@media (max-width: ${DESKTOP_BREAKPOINT}px) {
		display: none;
	}
`;

export const MobileFilter = styled.div`
	@media (min-width: ${DESKTOP_BREAKPOINT}px) {
		display: none;
	}
`;
